/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Dedup_Email_Exists_SearchInputs */



/**
* | output |
* | --- |
* | "A member already uses this email. Search for them by name or VEKN ID to register them." |
*
* @param {Create_Dedup_Email_Exists_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_dedup_email_exists_search = /** @type {((inputs?: Create_Dedup_Email_Exists_SearchInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Dedup_Email_Exists_SearchInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un membre utilise déjà cet email. Recherchez-le par nom ou VEKN ID pour l'inscrire.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un miembro ya usa este correo electrónico. Búsquelo por nombre o ID VEKN para inscribirlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um membro já usa este e-mail. Busque-o por nome ou VEKN ID para inscrevê-lo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un membro usa già questa email. Cercalo per nome o VEKN ID per iscriverlo.")
	return /** @type {LocalizedString} */ ("A member already uses this email. Search for them by name or VEKN ID to register them.")
});